/* PULSO — lo que se mueve solo: galeria, resenas y fecha de entrega. */
(function(){
  'use strict';

  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- la galeria avanza sola hasta que la tocan ----------
     Se detiene para siempre al primer toque: si el visitante esta
     mirando una foto, que la pagina se la cambie sola es molesto. */
  function galeriaAuto(){
    var minis = document.querySelectorAll('.gal__t');
    var foto  = document.getElementById('pulsoGalFoto');
    var caja  = document.querySelector('.gal');
    if(quieto || minis.length < 2 || !foto || !caja) return;

    var i = 0, reloj = null, detenida = false;

    function avanza(){
      if(detenida) return;
      i = (i + 1) % minis.length;
      var marco = foto.parentElement;
      marco.classList.add('cambiando');
      setTimeout(function(){
        minis[i].click();
        marco.classList.remove('cambiando');
      }, 200);
    }

    function detener(){
      detenida = true;
      if(reloj){ clearInterval(reloj); reloj = null; }
    }

    ['click','touchstart','keydown'].forEach(function(ev){
      caja.addEventListener(ev, detener, { once:true, passive:true });
    });

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(x){
          if(detenida) return;
          if(x.isIntersecting){ if(!reloj) reloj = setInterval(avanza, 3200); }
          else if(reloj){ clearInterval(reloj); reloj = null; }
        });
      }, { threshold:.4 }).observe(caja);
    } else {
      reloj = setInterval(avanza, 3200);
    }
  }

  /* ---------- carrusel de resenas: avanza solo y marca la posicion ---------- */
  function resenasAuto(){
    var pista = document.querySelector('.res');
    if(!pista) return;
    var cards = pista.querySelectorAll('.res__c');
    if(cards.length < 2) return;

    /* los puntos solo tienen sentido cuando la pista se desliza (movil) */
    if(pista.scrollWidth <= pista.clientWidth + 8) return;
    if(pista.parentNode.querySelector('.pulso-puntos')) return;

    var puntos = document.createElement('div');
    puntos.className = 'pulso-puntos';
    cards.forEach(function(){ puntos.appendChild(document.createElement('i')); });
    pista.parentNode.insertBefore(puntos, pista.nextSibling);
    var bolitas = puntos.querySelectorAll('i');

    function pinta(){
      var n = Math.round(pista.scrollLeft / (pista.scrollWidth / cards.length));
      bolitas.forEach(function(b, k){ b.classList.toggle('on', k === Math.min(n, cards.length - 1)); });
    }
    pinta();

    var esperando = false;
    pista.addEventListener('scroll', function(){
      if(!esperando){ requestAnimationFrame(function(){ pinta(); esperando = false; }); esperando = true; }
    }, { passive:true });

    if(quieto) return;

    var reloj = null, tocada = false;
    ['touchstart','pointerdown','wheel'].forEach(function(ev){
      pista.addEventListener(ev, function(){
        tocada = true;
        if(reloj){ clearInterval(reloj); reloj = null; }
      }, { once:true, passive:true });
    });

    function avanza(){
      if(tocada) return;
      var paso = pista.scrollWidth / cards.length;
      var fin  = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 8;
      pista.scrollTo({ left: fin ? 0 : pista.scrollLeft + paso, behavior:'smooth' });
    }

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(x){
          if(tocada) return;
          if(x.isIntersecting){ if(!reloj) reloj = setInterval(avanza, 4200); }
          else if(reloj){ clearInterval(reloj); reloj = null; }
        });
      }, { threshold:.3 }).observe(pista);
    }
  }

  /* ---------- ventana de entrega, calculada de verdad ----------
     Se muestra un RANGO, no un dia exacto: Chile es muy largo y a
     Punta Arenas o Aysen no llega en lo mismo que a Santiago.
     Prometer un dia puntual se paga con rechazos en la puerta. */
  function fechaEntrega(){
    var caja = document.querySelector('[data-entrega]');
    if(!caja) return;

    var min = parseInt(caja.dataset.diasMin, 10) || 2;
    var max = parseInt(caja.dataset.diasMax, 10) || 5;
    var corte = parseInt(caja.dataset.corte, 10);

    var DIAS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio',
                 'agosto','septiembre','octubre','noviembre','diciembre'];

    /* si ya paso la hora de corte, el despacho sale al dia siguiente */
    var extra = (!isNaN(corte) && new Date().getHours() >= corte) ? 1 : 0;

    function habil(n){
      var d = new Date(), contados = 0;
      while(contados < n){
        d.setDate(d.getDate() + 1);
        var dia = d.getDay();
        if(dia !== 0 && dia !== 6) contados++;   /* salta sabado y domingo */
      }
      return d;
    }
    function nombra(d){ return DIAS[d.getDay()] + ' ' + d.getDate(); }

    var a = habil(min + extra);
    var b = habil(max + extra);

    var destino = caja.querySelector('[data-entrega-rango]');
    if(destino){
      destino.textContent = (a.getMonth() === b.getMonth())
        ? nombra(a) + ' y el ' + nombra(b) + ' de ' + MESES[b.getMonth()]
        : nombra(a) + ' de ' + MESES[a.getMonth()] + ' y el ' + nombra(b) + ' de ' + MESES[b.getMonth()];
    }
    caja.hidden = false;
  }

  function arranca(){ galeriaAuto(); resenasAuto(); fechaEntrega(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }

  document.addEventListener('shopify:section:load', arranca);
})();